import useCheckArsStatus from "../features/Incomming/hooks/useCheckArsStatus";
//url 인입, ars 상태 확인
const IncomingPage = () => {
  useCheckArsStatus();
  return;
};

export default IncomingPage;
